import React, { useState } from "react";
import {
  FaMapMarkerAlt,
  FaRulerCombined,
  FaRuler,
  FaVectorSquare,
  FaFileImage,
  FaDollarSign,
  FaGavel,
} from "react-icons/fa";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import PriceChangeOutlinedIcon from "@mui/icons-material/PriceChangeOutlined";
import { FaStar, FaCheckCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { timeAgo } from "../../../Helper/CommonFunctions";
import { MonthYearDisplay } from "../../../Helper/CommonFunctions";
import rightIcon from "../../../assets/img/right icon.svg";
import profile from "../../../assets/img/profile professionals interested.svg";
import DimensionSummary from "../JobDetails/DimensionSummary/DimensionSummary";
import { Star, CheckCircle, Shield } from "lucide-react";
import winJobs from "../../../assets/img/win jobs.svg";
import tick from "../../../assets/img/tick signup-three icon.svg";

const BidJobDetails = ({ jobData }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [localJobData, setLocalJobData] = useState(jobData);
  const [activeTab, setActiveTab] = useState("details");
  const [showImg, setShowImg] = useState(false);
  const [showImg1, setShowImg1] = useState(false);

  const contractor = {
    name: "Mike's Construction",
    initial: "M",
    rating: 4.9,
    reviews: 156,
    price: 7500,
    duration: "5 weeks",
    description:
      "I have 15 years of experience in kitchen renovations and would love to work on your project.",
    submittedTime: "2 hours ago",
    isVerified: true,
    isTopRated: true,
    isOnline: true,
  };

  return (
    <div className="project-tabs">
      <header className="project-header">
        <div className="header-top">
          <div className="content_header">
            <h2>{localJobData?.title}</h2>
          </div>
          <p>
            <FaMapMarkerAlt /> {localJobData?.city}, {localJobData?.state} •{" "}
            {parseInt(localJobData?.distanceInMiles || 0)} miles{" "}
            <span className="ms-2">
              <AccessTimeOutlinedIcon /> {timeAgo(localJobData?.createdAt)}
            </span>
          </p>
        </div>
        <div className="budget-section">
          <h3>
            ${localJobData?.budgetMinimum || 0} - $
            {localJobData?.budgetMaximum || 0}
          </h3>
          <p>
            {localJobData?.installedDateStart}{" "}
            <span>
              Monthly Payment Budget: ${localJobData?.monthlyPayments || 0}
              /month
            </span>
          </p>
        </div>
        <div>
          <p>
            <PriceChangeOutlinedIcon /> {localJobData?.bidCount} bids{" "}
            <span className="ms-2">
              <VisibilityOutlinedIcon /> {localJobData?.viewCount} views
            </span>
          </p>
        </div>
        {/* <div className="action-buttons">
          <button className="info" onClick={openModal}>
            Request More Information
          </button>
          <button className="bid" onClick={() => handleSubmitBid(localJobData)}>
            Submit Your Bid
          </button>
        </div> */}
      </header>

      <div className="tabs">
        <button
          className={activeTab === "details" ? "active" : ""}
          onClick={() => setActiveTab("details")}
        >
          Project Details
        </button>
        <button
          className={activeTab === "client" ? "active" : ""}
          onClick={() => setActiveTab("client")}
        >
          Client
        </button>
        <button
          className={activeTab === "bids" ? "active" : ""}
          onClick={() => setActiveTab("bids")}
        >
          Bids ({localJobData?.bidCount || 0})
        </button>
      </div>

      <div className="tab-content">
        {activeTab === "details" && (
          <>
            <section className="photos">
              <h5>Project Photos</h5>
              <div className="photo-grid">
                {localJobData?.media && localJobData.media.length > 0 ? (
                  localJobData.media.map((mediaUrl, index) => (
                    <img
                      key={index}
                      src={mediaUrl}
                      alt={`project-media-${index}`}
                    />
                  ))
                ) : (
                  <img
                    src="https://images.unsplash.com/photo-1560807707-8cc77767d783?w=400"
                    alt="house1"
                  />
                )}
              </div>
            </section>

            <section className="description">
              <h5>Project Description</h5>
              <p>{localJobData?.description}</p>
            </section>

            <section className="details">
              <h5>Project Details</h5>
              <div className="detail-item">
                <div className="detail-item-1">
                  <FaRulerCombined />
                  <div>
                    <p>Square Footage:</p>
                    <span>Total Area</span>
                  </div>
                </div>
                <div className="detail-item-2">
                  {localJobData?.totalSquareFoot} sq ft
                </div>
              </div>
              <div className="detail-item">
                <div className="detail-item-1">
                  <FaRuler />
                  <div>
                    <p>Linear Feet</p>
                    <span>Total length</span>
                  </div>
                </div>
                <div className="detail-item-2">
                  {localJobData?.linearSquareFoot} ft
                </div>
              </div>
              <div
                className="detail-item"
                onClick={() => setShowImg1(!showImg1)}
              >
                <div className="detail-item-1">
                  <FaVectorSquare />
                  <div>
                    <p>Dimensions</p>
                    <span>Layout info</span>
                  </div>
                </div>
                <div className="detail-item-2">
                  4 Areas
                  <img src={rightIcon} alt="right icon" className="ms-1" />
                </div>
              </div>
              {showImg1 && <DimensionSummary />}

              <div className="detail-item" onClick={() => setShowImg(!showImg)}>
                <div className="detail-item-1">
                  <FaFileImage />
                  <div>
                    <p>Media</p>
                    <span>Photos & videos</span>
                  </div>
                </div>
                <div className="detail-item-2">
                  {localJobData?.media?.length || 0} Files{" "}
                  <img src={rightIcon} alt="right icon" className="ms-1" />
                </div>
              </div>
              {showImg && (
                <img
                  src="https://images.unsplash.com/photo-1560807707-8cc77767d783?w=400"
                  alt="house1"
                  className="media_img_show"
                />
              )}
            </section>

            <section className="budget-box">
              <div className="budget">
                <div className="budget-info">
                  <FaDollarSign />
                  <div style={{ whiteSpace: "nowrap" }}>
                    <h4>Budget Range</h4>
                    <span>Total Project cost</span>
                  </div>
                </div>

                <div style={{ width: "100%" }}>
                  <h4 style={{ textAlign: "end" }}>
                    ${localJobData?.budgetMinimum || 0} - $
                    {localJobData?.budgetMaximum || 0}
                  </h4>
                  <small style={{ textAlign: "end" }}>
                    Monthly Payment: ${localJobData?.monthlyPayments || 0}
                    /month
                  </small>
                </div>
              </div>
            </section>

            <section className="concerns">
              <h5>Concerns</h5>
              <div className="tags">
                {localJobData?.concerns &&
                  localJobData.concerns.map((concern, index) => (
                    <span key={index}>{concern.trim()}</span>
                  ))}
              </div>
            </section>
          </>
        )}

        {activeTab === "client" && (
          <div className="homeowner-card">
            <img
              src={
                localJobData?.userId?.profileImage ||
                "https://images.unsplash.com/photo-1560807707-8cc77767d783?w=400"
              }
              alt="Homeowner"
              className="profile-photo"
            />
            <h3>
              {localJobData?.userId?.firstName} {localJobData?.userId?.lastName}{" "}
              <FaCheckCircle className="verified-icon" />
            </h3>
            <div className="rating">
              <FaStar className="star" />
              <span>{localJobData?.userId?.overAllStarRating || 0}</span>
              <span className="reviews">
                ({localJobData?.userId?.reviewCount || 0} reviews)
              </span>
            </div>
            <p className="member-since">
              Member since{" "}
              {MonthYearDisplay({
                dateString: localJobData?.userId?.createdAt,
              })}
            </p>

            <div className="stats">
              <div className="stat-box">
                <div className="number">
                  {localJobData?.userId?.totalCompletedJobs || 0}
                </div>
                <div className="label">Projects Completed</div>
              </div>
              <div className="stat-box">
                <div className="number">
                  {localJobData?.userId?.overAllRating || 0}
                </div>
                <div className="label">Average Rating</div>
              </div>
            </div>

            {/* <button
              className="communicate-btn"
              onClick={() => handleSubmitBid(localJobData)}
            >
              Submit your bid to start communicating <br /> with the homeowner
            </button> */}
          </div>
        )}

        {activeTab === "bids" && (
          <>
            <div className="interested-card">
              <div className="icon-placeholder">
                <span role="img" aria-label="users">
                  <img src={profile} alt="profile" />
                </span>
              </div>
              <h3 className="count">
                {localJobData?.bidCount || 0} professionals interested
              </h3>
              <p className="info">
                Other professionals’ bids are private. <br />
                Submit your bid to participate in this project.
              </p>
              <div className="bid-box">
                <p>
                  Your bid will appear here once submitted <br />
                  and will be visible to the homeowner.
                </p>
              </div>
            </div>

            <div className="contractor-card">
              <div className="card-header">
                <div className="profile-section">
                  <div className="avatar-container">
                    <div className="avatar">{contractor.initial}</div>
                    {contractor.isOnline && (
                      <div className="online-indicator" />
                    )}
                  </div>

                  <div className="profile-info">
                    <div className="name-badges">
                      <h3 className="contractor-name">{contractor.name}</h3>
                      <div className="badges">
                        {contractor.isVerified && (
                          <img
                            src={tick}
                            alt="verified"
                            className="badge-icon verified"
                            width={40}
                            height={40}
                          />
                        )}
                        {contractor.isTopRated && (
                          <img
                            src={winJobs}
                            alt="win jobs"
                            className="badge-icon top-rated"
                            width={40}
                            height={40}
                          />
                        )}
                      </div>
                    </div>
                    <div className="rating-section">
                      <Star
                        className="star-icon"
                        size={14}
                        fill="#f59e0b"
                        strokeWidth={0}
                      />
                      <span className="rating">{contractor.rating}</span>
                      <span className="reviews">
                        • {contractor.reviews} reviews
                      </span>
                    </div>
                  </div>
                </div>

                <div className="price-section">
                  <div className="price">
                    ${contractor.price.toLocaleString()}
                  </div>
                  <div className="duration">{contractor.duration}</div>
                </div>
              </div>

              <div className="card-body">
                <p className="description">{contractor.description}</p>
              </div>

              <div className="card-footer-p">
                <span className="submitted-time">
                  Submitted {contractor.submittedTime}
                </span>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
export default BidJobDetails;
